/**
 * 认证
 *
 */
export class AuthenticationService {
    constructor(serviceBus, coreAuthAppId) {
        this.coreAuthAppId = `core/authentication`;
        this.serviceBus = serviceBus;
        const _coreAuthAppId = coreAuthAppId ? coreAuthAppId : this.coreAuthAppId;
        this.serviceBusClient = serviceBus.getClient(_coreAuthAppId);
    }
    signIn() {
        return this.getServiceBusClient()
            .request({ type: 'signIn' })
            .toPromise()
            .then((s) => { });
    }
    signOut() {
        return this.getServiceBusClient()
            .request({ type: 'signOut' })
            .toPromise()
            .then((s) => { });
    }
    setAuthentication(user) {
        this._user = user;
    }
    getAuthentication() {
        if (this._user) {
            return this._user;
        }
        return null;
    }
    // 主应用加载时，认证子应用不一定加载完
    getServiceBusClient() {
        if (this.serviceBusClient.initState === 'success') {
            return this.serviceBusClient;
        }
        this.serviceBusClient.init();
        return this.serviceBusClient;
    }
}
